export const LINDUA_ICONS: string[] = [
	"icon-3d-glasses",
	"icon-accessibility",
	"icon-aim",
	"icon-airplane",
	"icon-airplane-cross",
	"icon-alarm",
	"icon-alarm-check",
	"icon-alarm-cross",
	"icon-alarm-minus",
	"icon-alarm-plus",
	"icon-alarm2",
	"icon-album",
	"icon-alien",
	"icon-align-bottom",
	"icon-align-center-horizontal",
	"icon-align-center-vertical",
	"icon-align-left",
	"icon-align-right",
	"icon-align-top",
	"icon-ambulance",
	"icon-anchor",
	"icon-angle",
	"icon-angle2",
	"icon-angry",
	"icon-antenna",
	"icon-anvil",
	"icon-apple",
	"icon-apple-check",
	"icon-apps",
	"icon-apps2",
	"icon-apps3",
	"icon-apps4",
	"icon-archery",
	"icon-arrow-down",
	"icon-arrow-down-circle",
	"icon-arrow-down-square",
	"icon-arrow-left",
	"icon-arrow-left-circle",
	"icon-arrow-left-square",
	"icon-arrow-ne",
	"icon-arrow-nw",
	"icon-arrow-right",
	"icon-arrow-right-circle",
	"icon-arrow-right-square",
	"icon-arrow-se",
	"icon-arrow-sw",
	"icon-arrow-up",
	"icon-arrow-up-circle",
	"icon-arrow-up-square",
	"icon-at-sign",
	"icon-atom",
	"icon-axe",
	"icon-axe2",
	"icon-baby",
	"icon-baby-bottle",
	"icon-baby-crying",
	"icon-baby-crying2",
	"icon-baby-smile",
	"icon-baby-tongue",
	"icon-baby-tongue2",
	"icon-baby2",
	"icon-baby3",
	"icon-backward",
	"icon-backward-circle",
	"icon-backward-square",
	"icon-baffled",
	"icon-bag",
	"icon-bag-check",
	"icon-bag-checkout",
	"icon-bag-cross",
	"icon-bag-full",
	"icon-bag-minus",
	"icon-bag-plus",
	"icon-balance",
	"icon-balloon",
	"icon-bandage",
	"icon-bandages",
	"icon-barcode",
	"icon-barcode2",
	"icon-barcode3",
	"icon-baseball",
	"icon-baseball-bat",
	"icon-basket",
	"icon-basketball",
	"icon-bathroom-scale",
	"icon-bathtub",
	"icon-battery-10",
	"icon-battery-100",
	"icon-battery-25",
	"icon-battery-40",
	"icon-battery-50",
	"icon-battery-60",
	"icon-battery-75",
	"icon-battery-90",
	"icon-battery-bolt",
	"icon-battery-check",
	"icon-battery-cross",
	"icon-battery-droplet",
	"icon-battery-empty",
	"icon-battery-plug",
	"icon-battery-plug-10",
	"icon-battery-plug-100",
	"icon-battery-plug-25",
	"icon-battery-plug-40",
	"icon-battery-plug-50",
	"icon-battery-plug-60",
	"icon-battery-plug-75",
	"icon-battery-plug-90",
	"icon-battery-plug2",
	"icon-battery-plus",
	"icon-battery-question",
	"icon-battery-warning",
	"icon-beaker",
	"icon-bed",
	"icon-bed-check",
	"icon-bed-cross",
	"icon-bed-time",
	"icon-bell",
	"icon-bell-minus",
	"icon-bell-music",
	"icon-bell-plus",
	"icon-bell-ringing",
	"icon-bell-ringing2",
	"icon-bell-snooze",
	"icon-bell-warning",
	"icon-bell2",
	"icon-bezier-curve",
	"icon-bezier-curve2",
	"icon-bicycle",
	"icon-bicycle-riding",
	"icon-bill",
	"icon-bill-dollar",
	"icon-bill-euro",
	"icon-bill-pound",
	"icon-bill-ruble",
	"icon-bill-stack",
	"icon-bill-stack-dollar",
	"icon-bill-stack-euro",
	"icon-bill-stack-pound",
	"icon-bill-stack-ruble",
	"icon-bill-stack-yen",
	"icon-bill-yen",
	"icon-bill2",
	"icon-binoculars",
	"icon-binoculars2",
	"icon-blog",
	"icon-boat",
	"icon-bold",
	"icon-bomb",
	"icon-bone",
	"icon-book",
	"icon-book-audio",
	"icon-book-bookmarked",
	"icon-book-bookmarked2",
	"icon-book2",
	"icon-book3",
	"icon-bookmark",
	"icon-bookmark-minus",
	"icon-bookmark-move",
	"icon-bookmark-plus",
	"icon-books",
	"icon-border-color",
	"icon-bottle",
	"icon-bottle2",
	"icon-bow-tie",
	"icon-bowler-hat",
	"icon-bowling-ball",
	"icon-box",
	"icon-box-check",
	"icon-box-check2",
	"icon-box-cross",
	"icon-box-cross2",
	"icon-box2",
	"icon-box3",
	"icon-bra",
	"icon-branches",
	"icon-branches2",
	"icon-bricks",
	"icon-briefcase",
	"icon-briefcase-money",
	"icon-briefcase-question",
	"icon-brightness",
	"icon-brightness-auto",
	"icon-brightness-auto2",
	"icon-brightness-contrast",
	"icon-bring-forward",
	"icon-brush",
	"icon-brush2",
	"icon-bubble",
	"icon-bubble-check",
	"icon-bubble-cross",
	"icon-bubble-dots",
	"icon-bubble-emoji",
	"icon-bubble-exclamation",
	"icon-bubble-friend",
	"icon-bubble-friend-plus",
	"icon-bubble-heart",
	"icon-bubble-mad",
	"icon-bubble-music",
	"icon-bubble-music2",
	"icon-bubble-paperclip",
	"icon-bubble-picture",
	"icon-bubble-poker-face",
	"icon-bubble-question",
	"icon-bubble-quote",
	"icon-bubble-sad",
	"icon-bubble-shiny",
	"icon-bubble-shocked",
	"icon-bubble-text",
	"icon-bubble-text2",
	"icon-bubble-time",
	"icon-bubble-video",
	"icon-bubble-writing",
	"icon-bubbles",
	"icon-bubbles2",
	"icon-bucket",
	"icon-bug",
	"icon-bug2",
	"icon-burger",
	"icon-bus",
	"icon-bus2",
	"icon-business-card",
	"icon-button",
	"icon-button2",
	"icon-cabinet",
	"icon-cable",
	"icon-cactus",
	"icon-cake",
	"icon-calculator",
	"icon-calculator2",
	"icon-calendar",
	"icon-calendar-check",
	"icon-calendar-cross",
	"icon-calendar-minus",
	"icon-calendar-plus",
	"icon-calendar-time",
	"icon-calendar-user",
	"icon-calendar2",
	"icon-calendar3",
	"icon-calendar4",
	"icon-camera",
	"icon-camera-cross",
	"icon-camera-flip",
	"icon-camera-pause",
	"icon-camera-play",
	"icon-camera-record",
	"icon-camera-stabilization",
	"icon-camera-stop",
	"icon-camera-time",
	"icon-camera-time2",
	"icon-camera2",
	"icon-camera3",
	"icon-candy",
	"icon-canvas",
	"icon-canvas-bottom",
	"icon-canvas-center",
	"icon-canvas-fit",
	"icon-canvas-left",
	"icon-canvas-right",
	"icon-canvas-top",
	"icon-capacitor",
	"icon-car",
	"icon-car-battery",
	"icon-car-check",
	"icon-car-cross",
	"icon-car-lock",
	"icon-car-lock2",
	"icon-car-parking",
	"icon-car-parking2",
	"icon-car-plug",
	"icon-car-wash",
	"icon-car2",
	"icon-carrot",
	"icon-cart",
	"icon-cart-check",
	"icon-cart-checkout",
	"icon-cart-cross",
	"icon-cart-full",
	"icon-cart-load",
	"icon-cart-manage",
	"icon-cart-minus",
	"icon-cart-plus",
	"icon-cart-unload",
	"icon-cassette",
	"icon-ccw",
	"icon-ccw2",
	"icon-certificate",
	"icon-certificate2",
	"icon-chair",
	"icon-charging-station",
	"icon-chart",
	"icon-chart-circle",
	"icon-chart-downward",
	"icon-chart-square",
	"icon-chart-upward",
	"icon-check",
	"icon-check-circle",
	"icon-check-square",
	"icon-checkbox-unchecked",
	"icon-checklist",
	"icon-checklist-time",
	"icon-checklist2",
	"icon-cheese",
	"icon-chef",
	"icon-cherry",
	"icon-chevron-down",
	"icon-chevron-down-circle",
	"icon-chevron-down-square",
	"icon-chevron-left",
	"icon-chevron-left-circle",
	"icon-chevron-left-square",
	"icon-chevron-right",
	"icon-chevron-right-circle",
	"icon-chevron-right-square",
	"icon-chevron-up",
	"icon-chevron-up-circle",
	"icon-chevron-up-square",
	"icon-chicken-leg",
	"icon-christmas-tree",
	"icon-cigar",
	"icon-cigar-no",
	"icon-cigar-warning",
	"icon-circle-extract",
	"icon-circle-insert",
	"icon-citrus",
	"icon-city",
	"icon-clapboard",
	"icon-clapboard-play",
	"icon-cli",
	"icon-clipboard-chart",
	"icon-clipboard-check",
	"icon-clipboard-down",
	"icon-clipboard-empty",
	"icon-clipboard-left",
	"icon-clipboard-list",
	"icon-clipboard-pencil",
	"icon-clipboard-text",
	"icon-clipboard-user",
	"icon-clipboard-warning",
	"icon-clock",
	"icon-cloud",
	"icon-cloud-backup",
	"icon-cloud-bolt",
	"icon-cloud-check",
	"icon-cloud-connected",
	"icon-cloud-cross",
	"icon-cloud-database",
	"icon-cloud-download",
	"icon-cloud-fog",
	"icon-cloud-lock",
	"icon-cloud-message",
	"icon-cloud-music",
	"icon-cloud-music2",
	"icon-cloud-rain",
	"icon-cloud-rain2",
	"icon-cloud-rain3",
	"icon-cloud-settings",
	"icon-cloud-snow",
	"icon-cloud-snow2",
	"icon-cloud-sun",
	"icon-cloud-sync",
	"icon-cloud-time",
	"icon-cloud-upload",
	"icon-cloud-warning",
	"icon-cloud-wind",
	"icon-clubs",
	"icon-clubs2",
	"icon-code",
	"icon-code-circle",
	"icon-code-square",
	"icon-coffee-bean",
	"icon-coffee-maker",
	"icon-coffee-pot",
	"icon-color-sampler",
	"icon-combine",
	"icon-communication",
	"icon-communication-cross",
	"icon-compass",
	"icon-compass2",
	"icon-compass3",
	"icon-concave",
	"icon-confused",
	"icon-connection",
	"icon-connection-warning",
	"icon-construction",
	"icon-construction-cone",
	"icon-contacts",
	"icon-contrast",
	"icon-convex",
	"icon-conveyor",
	"icon-cool",
	"icon-coolant",
	"icon-cosine",
	"icon-couch",
	"icon-cpu",
	"icon-cpu-x64",
	"icon-cpu-x86",
	"icon-crop",
	"icon-crop-rotate",
	"icon-crop2",
	"icon-cross",
	"icon-cross-circle",
	"icon-cross-circle2",
	"icon-cross-square",
	"icon-cross-square2",
	"icon-crown",
	"icon-crystal-ball",
	"icon-cube",
	"icon-cube-3d",
	"icon-cube-bottom",
	"icon-cube-front",
	"icon-cube-side",
	"icon-cube-top",
	"icon-cutter",
	"icon-cw",
	"icon-cw-bolt",
	"icon-cw2",
	"icon-database",
	"icon-database-backup",
	"icon-database-check",
	"icon-database-download",
	"icon-database-lock",
	"icon-database-minus",
	"icon-database-plus",
	"icon-database-sync",
	"icon-database-time",
	"icon-database-upload",
	"icon-dead",
	"icon-debit-card",
	"icon-delete",
	"icon-depressed",
	"icon-diamond",
	"icon-diamond2",
	"icon-diamonds",
	"icon-diamonds2",
	"icon-dice",
	"icon-direction-ltr",
	"icon-direction-rtl",
	"icon-disc",
	"icon-disc-audio",
	"icon-disc-brake",
	"icon-disc-play",
	"icon-disposal",
	"icon-diving",
	"icon-diving-mask",
	"icon-diving-warning",
	"icon-dna",
	"icon-dna-code",
	"icon-donut",
	"icon-dork",
	"icon-download",
	"icon-download-circle",
	"icon-download-square",
	"icon-drawer",
	"icon-drawer-download",
	"icon-drawer-full",
	"icon-drawer-full2",
	"icon-drawer-paper",
	"icon-drawer-paper2",
	"icon-drawer-sync",
	"icon-drawer-upload",
	"icon-drawer-warning",
	"icon-dreaming",
	"icon-dresser",
	"icon-dresser2",
	"icon-drop",
	"icon-dropdown",
	"icon-droplet-cross",
	"icon-droplet-minus",
	"icon-droplet-plus",
	"icon-droplets",
	"icon-dumbbell",
	"icon-earphones",
	"icon-earth",
	"icon-earth-lock",
	"icon-easter-egg",
	"icon-edit",
	"icon-edit2",
	"icon-edit3",
	"icon-egg",
	"icon-egg-broken",
	"icon-eject",
	"icon-eject-circle",
	"icon-eject-square",
	"icon-ellipsis",
	"icon-emerald",
	"icon-engine",
	"icon-enter",
	"icon-enter2",
	"icon-envelope",
	"icon-envelope-check",
	"icon-envelope-cross",
	"icon-envelope-open",
	"icon-envelope-open2",
	"icon-envelope-plus",
	"icon-envelope-warning",
	"icon-equalizer",
	"icon-equalizer2",
	"icon-equals-circle",
	"icon-equals-square",
	"icon-eraser",
	"icon-escalator-down",
	"icon-escalator-up",
	"icon-evil",
	"icon-exclamation",
	"icon-exclude",
	"icon-exit",
	"icon-expand",
	"icon-expand-horizontal",
	"icon-expand-square",
	"icon-expand-square2",
	"icon-expand-vertical",
	"icon-expand2",
	"icon-explosion",
	"icon-exposure",
	"icon-external",
	"icon-external2",
	"icon-extinguisher",
	"icon-extract-down",
	"icon-extract-left",
	"icon-extract-right",
	"icon-extract-up",
	"icon-eye",
	"icon-eye-cross",
	"icon-eye-droplet",
	"icon-eye-minus",
	"icon-eye-plus",
	"icon-eye2",
	"icon-eyedropper",
	"icon-face-detection",
	"icon-factory",
	"icon-fan",
	"icon-fan2",
	"icon-fan3",
	"icon-faucet",
	"icon-female",
	"icon-fence",
	"icon-fencing",
	"icon-file-chart",
	"icon-file-chart-bars",
	"icon-file-check",
	"icon-file-code",
	"icon-file-compressed",
	"icon-file-empty",
	"icon-file-lock",
	"icon-file-magnifier",
	"icon-file-music",
	"icon-file-pencil",
	"icon-file-picture",
	"icon-file-plus",
	"icon-file-preview",
	"icon-file-spreadsheet",
	"icon-file-text",
	"icon-file-user",
	"icon-file-video",
	"icon-files",
	"icon-files-compare",
	"icon-files2",
	"icon-film",
	"icon-film-play",
	"icon-film-play2",
	"icon-find-replace",
	"icon-fingerprint",
	"icon-fire",
	"icon-fire-forbidden",
	"icon-fire-hazard",
	"icon-fire-price",
	"icon-fire-warning",
	"icon-fireworks",
	"icon-first",
	"icon-first-aid",
	"icon-first-aid-kit",
	"icon-first-circle",
	"icon-first-circle2",
	"icon-fish",
	"icon-fish-bowl",
	"icon-flag",
	"icon-flag2",
	"icon-flag3",
	"icon-flashlight",
	"icon-flashlight-bright",
	"icon-flask",
	"icon-flask-warning",
	"icon-flip-horizontal",
	"icon-flip-horizontal2",
	"icon-flip-vertical",
	"icon-flip-vertical2",
	"icon-floor-lamp",
	"icon-floppy-disk",
	"icon-flower",
	"icon-flower2",
	"icon-flower3",
	"icon-flying-saucer",
	"icon-flying-saucer2",
	"icon-focal-point",
	"icon-fold",
	"icon-folder",
	"icon-folder-camera",
	"icon-folder-code",
	"icon-folder-download",
	"icon-folder-film",
	"icon-folder-heart",
	"icon-folder-history",
	"icon-folder-home",
	"icon-folder-lock",
	"icon-folder-minus",
	"icon-folder-music",
	"icon-folder-music2",
	"icon-folder-picture",
	"icon-folder-plus",
	"icon-folder-search",
	"icon-folder-share",
	"icon-folder-star",
	"icon-folder-upload",
	"icon-folder-user",
	"icon-folder-video",
	"icon-folder-zip",
	"icon-football",
	"icon-footprint",
	"icon-fork",
	"icon-fork-knife",
	"icon-fork-knife2",
	"icon-fork-spoon",
	"icon-fork-spoon2",
	"icon-format-clear",
	"icon-format-shapes",
	"icon-forward",
	"icon-forward-10s",
	"icon-forward-5s",
	"icon-forward-circle",
	"icon-forward-square",
	"icon-free-transform",
	"icon-fried-egg",
	"icon-fries",
	"icon-full-screen-enter",
	"icon-full-screen-enter2",
	"icon-full-screen-exit",
	"icon-full-screen-exit2",
	"icon-funnel",
	"icon-gallon",
	"icon-game",
	"icon-gamepad",
	"icon-gas-mask",
	"icon-gas-station",
	"icon-gear",
	"icon-gear2",
	"icon-gear3",
	"icon-geek",
	"icon-gender",
	"icon-gender2",
	"icon-gesture-pinch",
	"icon-gesture-zoom",
	"icon-ghost",
	"icon-ghost-dead",
	"icon-ghost-neutral",
	"icon-gift",
	"icon-glass",
	"icon-glass-broken",
	"icon-glass-cocktail",
	"icon-glass2",
	"icon-glasses",
	"icon-glasses2",
	"icon-golf",
	"icon-gown",
	"icon-gradient",
	"icon-graduation",
	"icon-grape",
	"icon-grenade",
	"icon-grid",
	"icon-grid-cross",
	"icon-grin",
	"icon-grin-braces",
	"icon-grin-evil",
	"icon-grin-happy",
	"icon-group",
	"icon-group-circle",
	"icon-group-edit",
	"icon-group-minus",
	"icon-group-plus",
	"icon-group2",
	"icon-group3",
	"icon-guitar",
	"icon-guitar-electric",
	"icon-guitar-pick",
	"icon-gun",
	"icon-hairdryer",
	"icon-halloween",
	"icon-hammer",
	"icon-hammer-wrench",
	"icon-hammer2",
	"icon-hand-grip",
	"icon-hand-soap",
	"icon-hand-truck",
	"icon-handwriting",
	"icon-hanger",
	"icon-hanger2",
	"icon-happy",
	"icon-hard-disk",
	"icon-hard-disk-warning",
	"icon-head",
	"icon-head-bubble",
	"icon-head-hearing",
	"icon-head-money",
	"icon-head-processing",
	"icon-head-question",
	"icon-head-speech",
	"icon-headphones",
	"icon-headphones-cross",
	"icon-headphones-warning",
	"icon-headset",
	"icon-heart",
	"icon-heart-plus",
	"icon-heart-pulse",
	"icon-heart-shiny",
	"icon-heart-time",
	"icon-heart2",
	"icon-heart3",
	"icon-height",
	"icon-helicopter",
	"icon-helipad",
	"icon-helipad2",
	"icon-helm",
	"icon-high-heels",
	"icon-highlight",
	"icon-hiking",
	"icon-history",
	"icon-hockey",
	"icon-home",
	"icon-home-lock",
	"icon-home-sleep",
	"icon-home-smart",
	"icon-home-user",
	"icon-home2",
	"icon-home3",
	"icon-home4",
	"icon-hoodie",
	"icon-hook",
	"icon-horns",
	"icon-hot-dog",
	"icon-hotspot",
	"icon-hotspot2",
	"icon-hourglass",
	"icon-hydrant",
	"icon-ic",
	"icon-ice-cream",
	"icon-ice-cream-bar",
	"icon-import",
	"icon-indent-decrease",
	"icon-indent-increase",
	"icon-infinity-circle",
	"icon-infinity-square",
	"icon-info-circle",
	"icon-info-octagon",
	"icon-info-square",
	"icon-inhaler",
	"icon-insert-down",
	"icon-insert-left",
	"icon-insert-right",
	"icon-insert-up",
	"icon-insomnia",
	"icon-install",
	"icon-intersect",
	"icon-iron",
	"icon-iron-high",
	"icon-iron-low",
	"icon-iron-medium",
	"icon-iron-no",
	"icon-iron-steam",
	"icon-iron-steam-no",
	"icon-italic",
	"icon-jet-engine",
	"icon-jumping",
	"icon-key",
	"icon-key-hole",
	"icon-key2",
	"icon-keyboard",
	"icon-keyboard-hide",
	"icon-keyboard-key",
	"icon-keyboard-key-down",
	"icon-keyboard-key-up",
	"icon-keyboard-key2",
	"icon-keyboard-show",
	"icon-keyboard-wireless",
	"icon-kitchen-scale",
	"icon-knife",
	"icon-label",
	"icon-lamp",
	"icon-lamp-bright",
	"icon-lamp-check",
	"icon-lamp-gear",
	"icon-lamp-minus",
	"icon-lamp-plus",
	"icon-lamp-time",
	"icon-laptop",
	"icon-laptop-code",
	"icon-laptop-cross",
	"icon-laptop-education",
	"icon-laptop-phone",
	"icon-laptop-phone-sync",
	"icon-laptop-play",
	"icon-laptop-share",
	"icon-laptop-user",
	"icon-laptop-warning",
	"icon-last",
	"icon-last-circle",
	"icon-last-square",
	"icon-laundry-time",
	"icon-layers",
	"icon-layers-cross",
	"icon-leaf",
	"icon-leaf-check",
	"icon-leaf-cross",
	"icon-leaf-plus",
	"icon-leap-backward",
	"icon-leap-forward",
	"icon-led",
	"icon-led-bright",
	"icon-library",
	"icon-lifebuoy",
	"icon-ligature",
	"icon-lighter",
	"icon-lighthouse",
	"icon-line-spacing",
	"icon-link",
	"icon-link-cross",
	"icon-link2",
	"icon-lips",
	"icon-lipstick",
	"icon-list-heart",
	"icon-lock",
	"icon-lock-check",
	"icon-lock-cross",
	"icon-lock-warning",
	"icon-lock-wireless",
	"icon-lock2",
	"icon-lollipop",
	"icon-loudspeaker",
	"icon-loup-minus",
	"icon-loup-plus",
	"icon-loupe",
	"icon-luggage-weight",
	"icon-lungs",
	"icon-machine-wash",
	"icon-machine-wash-cold",
	"icon-machine-wash-hot",
	"icon-machine-wash-warm",
	"icon-mad",
	"icon-magic-wand",
	"icon-magnet",
	"icon-magnet-angle",
	"icon-magnet-cross",
	"icon-magnet-grid",
	"icon-magnet-point",
	"icon-magnet-scale",
	"icon-magnifier-bug",
	"icon-magnifier-check",
	"icon-magnifier-dollar",
	"icon-magnifier-euro",
	"icon-magnifier-marquee",
	"icon-magnifier-move",
	"icon-magnifier-next",
	"icon-magnifier-pound",
	"icon-magnifier-prev",
	"icon-magnifier-question",
	"icon-magnifier-ruble",
	"icon-magnifier-user",
	"icon-magnifier-yen",
	"icon-mailbox-empty",
	"icon-mailbox-full",
	"icon-male",
	"icon-map",
	"icon-map-marker",
	"icon-map-marker-check",
	"icon-map-marker-cross",
	"icon-map-marker-down",
	"icon-map-marker-edit",
	"icon-map-marker-minus",
	"icon-map-marker-plus",
	"icon-map-marker-user",
	"icon-map2",
	"icon-match-fire",
	"icon-medal-empty",
	"icon-medal-first",
	"icon-medal-second",
	"icon-medal-third",
	"icon-megaphone",
	"icon-megaphone2",
	"icon-menu",
	"icon-menu-circle",
	"icon-menu-square",
	"icon-menu2",
	"icon-merge",
	"icon-metronome",
	"icon-mic",
	"icon-mic-cross",
	"icon-mic-cross2",
	"icon-mic-settings",
	"icon-mic-two-way",
	"icon-mic-warning",
	"icon-mic-warning2",
	"icon-mic2",
	"icon-microscope",
	"icon-microsd",
	"icon-microsd-plus",
	"icon-microwave",
	"icon-milk-bottle",
	"icon-minus",
	"icon-minus-circle",
	"icon-minus-square",
	"icon-mirror",
	"icon-missed-incoming",
	"icon-missed-incoming2",
	"icon-missed-outgoing",
	"icon-missed-outgoing2",
	"icon-mixer",
	"icon-money-pouch",
	"icon-money-pouch-euro",
	"icon-money-pouch-pound",
	"icon-money-pouch-ruble",
	"icon-money-pouch-yen",
	"icon-monitor",
	"icon-monitor-play",
	"icon-monitor-share",
	"icon-moon",
	"icon-mouse",
	"icon-mouse-check",
	"icon-mouse-click-both",
	"icon-mouse-click-left",
	"icon-mouse-click-right",
	"icon-mouse-cross",
	"icon-mouse-network",
	"icon-mouse-wireless",
	"icon-move",
	"icon-move-bottom-down",
	"icon-move-bottom-up",
	"icon-move-down",
	"icon-move-left-left",
	"icon-move-left-right",
	"icon-move-right-left",
	"icon-move-right-right",
	"icon-move-top-down",
	"icon-move-top-up",
	"icon-move-up",
	"icon-mug",
	"icon-music-note",
	"icon-music-note-plus",
	"icon-music-note2",
	"icon-music-note3",
	"icon-music-note4",
	"icon-music-note5",
	"icon-music-note6",
	"icon-mustache",
	"icon-mustache-glasses",
	"icon-mustache-monocle",
	"icon-necktie",
	"icon-network",
	"icon-network2",
	"icon-neutral",
	"icon-news",
	"icon-newsletter",
	"icon-newsletters",
	"icon-next",
	"icon-next-circle",
	"icon-next-frame",
	"icon-next-frame-circle",
	"icon-next-frame-square",
	"icon-next-square",
	"icon-ninja",
	"icon-no",
	"icon-no-entry",
	"icon-notebook",
	"icon-nuclear",
	"icon-obelus",
	"icon-obelus-circle",
	"icon-obelus-square",
	"icon-office",
	"icon-oil-pressure",
	"icon-oil-price",
	"icon-ol",
	"icon-omega",
	"icon-pacifier",
	"icon-page-break",
	"icon-paint-roller",
	"icon-palette",
	"icon-palm",
	"icon-panorama",
	"icon-pants",
	"icon-paper",
	"icon-paper-cup",
	"icon-paper-plane",
	"icon-paper-towel",
	"icon-paperclip",
	"icon-paste",
	"icon-paste2",
	"icon-pause",
	"icon-pause-circle",
	"icon-pause-square",
	"icon-paw",
	"icon-pen",
	"icon-pen-drawing",
	"icon-pen-minus",
	"icon-pen-plus",
	"icon-pen2",
	"icon-pencil",
	"icon-pencil-ruler",
	"icon-pencil-ruler2",
	"icon-pencil2",
	"icon-pencil3",
	"icon-percent",
	"icon-percent-circle",
	"icon-percent-square",
	"icon-phone-24",
	"icon-phone-bubble",
	"icon-phone-cross",
	"icon-phone-end",
	"icon-phone-in-out",
	"icon-phone-incoming",
	"icon-phone-lock",
	"icon-phone-loudspeaker",
	"icon-phone-minus",
	"icon-phone-outgoing",
	"icon-phone-pause",
	"icon-phone-plus",
	"icon-phone-sip",
	"icon-phone-time",
	"icon-phone-user",
	"icon-photo-album",
	"icon-piano",
	"icon-pickaxe",
	"icon-picture",
	"icon-picture2",
	"icon-pie-chart",
	"icon-pig",
	"icon-piggy-bank",
	"icon-pilcrow",
	"icon-pills",
	"icon-ping-pong",
	"icon-pitcher",
	"icon-pizza",
	"icon-planet",
	"icon-platter",
	"icon-play",
	"icon-play-circle",
	"icon-play-square",
	"icon-playlist",
	"icon-playlist2",
	"icon-pleased",
	"icon-plotter",
	"icon-plug",
	"icon-plug-cross",
	"icon-plunger",
	"icon-plus",
	"icon-plus-circle",
	"icon-plus-minus",
	"icon-plus-minus-circle",
	"icon-plus-minus-square",
	"icon-plus-square",
	"icon-pocket-knife",
	"icon-podium",
	"icon-pointer",
	"icon-pointer-down",
	"icon-pointer-left",
	"icon-pointer-right",
	"icon-pointer-up",
	"icon-poker-face",
	"icon-police",
	"icon-polygon",
	"icon-polygon2",
	"icon-polygon3",
	"icon-pool",
	"icon-poop",
	"icon-portrait",
	"icon-portrait-female",
	"icon-portrait-male",
	"icon-portrait2",
	"icon-pot",
	"icon-pot-hot",
	"icon-pot-time",
	"icon-power",
	"icon-power-auto",
	"icon-power-cross",
	"icon-power-dollar",
	"icon-power-switch",
	"icon-power-switch2",
	"icon-power-warning",
	"icon-power2",
	"icon-previous",
	"icon-previous-circle",
	"icon-previous-frame",
	"icon-previous-frame-circle",
	"icon-previous-frame-square",
	"icon-previous-square",
	"icon-printer",
	"icon-printer-3d",
	"icon-priority-decrease",
	"icon-priority-increase",
	"icon-projector-screen-chart",
	"icon-projector-screen-collapsed",
	"icon-projector-screen-play",
	"icon-pulse",
	"icon-pushpin",
	"icon-pushpin-cross",
	"icon-pushpin2",
	"icon-puzzle",
	"icon-puzzle-check",
	"icon-puzzle-cross",
	"icon-puzzle-down",
	"icon-qrcode",
	"icon-quadcopter",
	"icon-question",
	"icon-question-circle",
	"icon-question-square",
	"icon-quill",
	"icon-quote-left",
	"icon-quote-right",
	"icon-radio",
	"icon-radio-checked",
	"icon-radio-unchecked",
	"icon-rank",
	"icon-rank2",
	"icon-rank3",
	"icon-razor",
	"icon-rb-flask",
	"icon-rb-flask-warning",
	"icon-read",
	"icon-receipt",
	"icon-record",
	"icon-recycle",
	"icon-recycle2",
	"icon-redo",
	"icon-reel",
	"icon-reflection",
	"icon-refresh-locked",
	"icon-refrigerator",
	"icon-refund",
	"icon-register",
	"icon-reminder",
	"icon-remote-control",
	"icon-remote-control2",
	"icon-repeat",
	"icon-repeat-infinite",
	"icon-repeat-once",
	"icon-reply",
	"icon-reply-all",
	"icon-resistor",
	"icon-resize",
	"icon-rewind-10s",
	"icon-rewind-5s",
	"icon-ring",
	"icon-road",
	"icon-road-sign",
	"icon-robot",
	"icon-robot-arm",
	"icon-rocket",
	"icon-rolling-pin",
	"icon-round-corner",
	"icon-router",
	"icon-router-warning",
	"icon-rowing",
	"icon-rubber-duck",
	"icon-ruby",
	"icon-ruler",
	"icon-rulers",
	"icon-running",
	"icon-sad",
	"icon-safe",
	"icon-satellite",
	"icon-satellite-dish",
	"icon-saw",
	"icon-scale-down",
	"icon-scale-up",
	"icon-scared",
	"icon-scatterplot",
	"icon-scissors",
	"icon-screwdriver",
	"icon-scroll-down",
	"icon-scroll-horizontal",
	"icon-scroll-left",
	"icon-scroll-right",
	"icon-scroll-up",
	"icon-scroll-vertical",
	"icon-search",
	"icon-select",
	"icon-self-timer",
	"icon-self-timer2",
	"icon-send-backward",
	"icon-server",
	"icon-settings-icons",
	"icon-share",
	"icon-share2",
	"icon-share3",
	"icon-shield",
	"icon-shield-bolt",
	"icon-shield-check",
	"icon-shield-cross",
	"icon-shield-droplet",
	"icon-shield-info",
	"icon-shield-plus",
	"icon-shield-star",
	"icon-shield-sync",
	"icon-shield-user",
	"icon-shield-warning",
	"icon-shield-web",
	"icon-ship",
	"icon-shirt",
	"icon-shocked",
	"icon-shocked2",
	"icon-shoe",
	"icon-shorts",
	"icon-shovel",
	"icon-shredder",
	"icon-shrink",
	"icon-shrink-horizontal",
	"icon-shrink-square",
	"icon-shrink-vertical",
	"icon-shrink2",
	"icon-shuffle",
	"icon-shutter",
	"icon-side-up-circle",
	"icon-side-up-square",
	"icon-sigma",
	"icon-signal",
	"icon-signal-1of4",
	"icon-signal-2of4",
	"icon-signal-3of4",
	"icon-signal-error",
	"icon-signal-lock",
	"icon-sim",
	"icon-sine",
	"icon-sink",
	"icon-sink2",
	"icon-siren",
	"icon-siren-bright",
	"icon-skating",
	"icon-skeptical",
	"icon-skull",
	"icon-slingshot",
	"icon-smartphone",
	"icon-smartphone-backup",
	"icon-smartphone-check",
	"icon-smartphone-code",
	"icon-smartphone-info",
	"icon-smartphone-lock",
	"icon-smartphone-pencil",
	"icon-smartphone-ringtone",
	"icon-smartphone-rotate",
	"icon-smartphone-silent",
	"icon-smartphone-speakers",
	"icon-smartphone-sync",
	"icon-smartphone-text",
	"icon-smartphone-time",
	"icon-smartphone-transfer",
	"icon-smartphone-user",
	"icon-smartphone-vibration",
	"icon-smartphone-warning",
	"icon-smartphone2",
	"icon-smiley",
	"icon-smirk",
	"icon-smirk-wink",
	"icon-snorkeling",
	"icon-snowflake",
	"icon-snowflake2",
	"icon-snowman",
	"icon-soccer",
	"icon-sock",
	"icon-sock-dirty",
	"icon-socket",
	"icon-solar-panel",
	"icon-solar-power",
	"icon-solar-power2",
	"icon-sophisticated",
	"icon-sort-alpha-asc",
	"icon-sort-alpha-desc",
	"icon-sort-numeric-asc",
	"icon-sort-numeric-desc",
	"icon-sort-size-asc",
	"icon-sort-size-desc",
	"icon-sort-time-asc",
	"icon-sort-time-desc",
	"icon-source",
	"icon-spades",
	"icon-spades2",
	"icon-speed-fast",
	"icon-speed-medium",
	"icon-speed-slow",
	"icon-spell-check",
	"icon-spinner",
	"icon-spinner2",
	"icon-spinner3",
	"icon-spinner4",
	"icon-split",
	"icon-spoon",
	"icon-spotlights",
	"icon-spray",
	"icon-spray-bug",
	"icon-spray-cross",
	"icon-spray2",
	"icon-squash",
	"icon-stairs",
	"icon-stamp",
	"icon-standing",
	"icon-star",
	"icon-star-empty",
	"icon-star-half",
	"icon-steak",
	"icon-stethoscope",
	"icon-sticker",
	"icon-stop",
	"icon-stop-circle",
	"icon-stop-square",
	"icon-stop2",
	"icon-stopwatch",
	"icon-stopwatch-cross",
	"icon-stopwatch-running",
	"icon-store",
	"icon-store-24",
	"icon-stream",
	"icon-stream-check",
	"icon-stream-cross",
	"icon-stream-warning",
	"icon-strikethrough",
	"icon-stroller",
	"icon-subscript",
	"icon-subtract",
	"icon-suit",
	"icon-sun",
	"icon-sun-fog",
	"icon-sun-wind",
	"icon-sunglasses",
	"icon-superscript",
	"icon-support",
	"icon-surveillance",
	"icon-surveillance2",
	"icon-swap-calls",
	"icon-swap-horizontal",
	"icon-swap-vertical",
	"icon-swimming",
	"icon-swimming-warning",
	"icon-swipe-down",
	"icon-swipe-horizontal",
	"icon-swipe-left",
	"icon-swipe-right",
	"icon-swipe-up",
	"icon-swipe-vertical",
	"icon-switch-off",
	"icon-switch-on",
	"icon-sword",
	"icon-sync",
	"icon-sync-cross",
	"icon-sync-gear",
	"icon-sync-warning",
	"icon-syringe",
	"icon-tab",
	"icon-table",
	"icon-tablet",
	"icon-tablet2",
	"icon-tag",
	"icon-tag2",
	"icon-tankard",
	"icon-tap",
	"icon-tap-all",
	"icon-tap-two",
	"icon-tape",
	"icon-tape-dispenser",
	"icon-tape-measure",
	"icon-target",
	"icon-taxi",
	"icon-tea-bag",
	"icon-teacup",
	"icon-telephone",
	"icon-telephone2",
	"icon-telephone3",
	"icon-telescope",
	"icon-tennis",
	"icon-tennis-ball",
	"icon-test-tube",
	"icon-text-align-center",
	"icon-text-align-justify",
	"icon-text-align-left",
	"icon-text-align-right",
	"icon-text-around",
	"icon-text-color",
	"icon-text-down",
	"icon-text-size",
	"icon-text-size-decrease",
	"icon-text-size-increase",
	"icon-text-size2",
	"icon-texture",
	"icon-theater",
	"icon-thermometer",
	"icon-thermometer-gear",
	"icon-thermometer-minus",
	"icon-thermometer-plus",
	"icon-thermometer-snow",
	"icon-thermometer-sun",
	"icon-thin",
	"icon-thumbs-down",
	"icon-thumbs-down2",
	"icon-thumbs-up",
	"icon-thumbs-up2",
	"icon-ticket",
	"icon-tile",
	"icon-tissue",
	"icon-toast",
	"icon-toaster",
	"icon-toggle-off",
	"icon-toggle-off2",
	"icon-toggle-on",
	"icon-toggle-on2",
	"icon-toilet-paper",
	"icon-tombstone",
	"icon-tongue",
	"icon-tongue-wink",
	"icon-toothbrush",
	"icon-top-hat",
	"icon-tornado",
	"icon-towel",
	"icon-traffic-lights",
	"icon-train",
	"icon-transfer-circle",
	"icon-transfer-square",
	"icon-transmission",
	"icon-trash",
	"icon-trash-cross",
	"icon-trash-cross2",
	"icon-trash-full",
	"icon-trash-warning",
	"icon-traveling",
	"icon-tren-circle",
	"icon-trend-square",
	"icon-trophy",
	"icon-trophy-first",
	"icon-trophy-second",
	"icon-trophy-third",
	"icon-trowel",
	"icon-truck",
	"icon-truck-arrow",
	"icon-truck-check",
	"icon-truck-cross",
	"icon-truck-scale",
	"icon-truck-time",
	"icon-tuning-fork",
	"icon-turntable",
	"icon-tv",
	"icon-ul",
	"icon-ul2",
	"icon-umbrella",
	"icon-umbrella-rain",
	"icon-underline",
	"icon-underwear",
	"icon-underwear2",
	"icon-undo",
	"icon-unfold",
	"icon-unlink",
	"icon-unlink2",
	"icon-unlock",
	"icon-unlock2",
	"icon-unlock3",
	"icon-unlock4",
	"icon-upload",
	"icon-upload-circle",
	"icon-upload-square",
	"icon-upload2",
	"icon-usb",
	"icon-usb-check",
	"icon-usb-cross",
	"icon-usb-drive",
	"icon-usb-minus",
	"icon-usb-plus",
	"icon-usb-question",
	"icon-usb-warning",
	"icon-user",
	"icon-user-24",
	"icon-user-bubble",
	"icon-user-check",
	"icon-user-cross",
	"icon-user-edit",
	"icon-user-gear",
	"icon-user-heart",
	"icon-user-info",
	"icon-user-lock",
	"icon-user-minus",
	"icon-user-plus",
	"icon-user-question",
	"icon-victory",
	"icon-voicemail",
	"icon-volcano",
	"icon-volume-0",
	"icon-volume-100",
	"icon-volume-25",
	"icon-volume-50",
	"icon-volume-75",
	"icon-volume-cross",
	"icon-walking",
	"icon-wallet",
	"icon-warning",
	"icon-warning-circle",
	"icon-warning-octagon",
	"icon-warning-square",
	"icon-washing-machine",
	"icon-watch",
	"icon-watch-handles",
	"icon-watch-handles2",
	"icon-watch-health",
	"icon-watch-warning",
	"icon-watch2",
	"icon-waving",
	"icon-webcam",
	"icon-weight",
	"icon-weight-1kg",
	"icon-weight-1lb",
	"icon-weight-1oz",
	"icon-weight-lifting",
	"icon-wheelchair",
	"icon-whistle",
	"icon-widescreen",
	"icon-widescreen-play",
	"icon-widescreen-user",
	"icon-wifi-100",
	"icon-wifi-100-warning",
	"icon-wifi-25",
	"icon-wifi-25-warning",
	"icon-wifi-50",
	"icon-wifi-50-warning",
	"icon-wifi-75",
	"icon-wifi-75-warning",
	"icon-wifi-cross",
	"icon-wifi-lock",
	"icon-wind",
	"icon-window",
	"icon-window-tab",
	"icon-window-tab-plus",
	"icon-window2",
	"icon-wink",
	"icon-witch-hat",
	"icon-wondering",
	"icon-wrench",
	"icon-wrench-screwdriver",
	"icon-wrench2",
	"icon-yacht",
	"icon-zipped",
	"icon-zoom-in",
	"icon-zoom-out",
];
